import { ExternalPayloadsService_externalPayloadsServiceGetEntity } from '@festina/moneyin-general-types/moneyin/hooks/ExternalPayloadsService_externalPayloadsServiceGetEntity'

export const useLazyFetchMoneyInExternalPayload =
  ExternalPayloadsService_externalPayloadsServiceGetEntity.useLazyQuery
